module.exports = __webpack_public_path__ + "img/JudeValentin.862c1d79.jpg";